import React from 'react';

const NewOldButton = ({ state, newOld }) => {
    return (
        <div className=' tc dt pa2 ma1 w-50 bg-dark-gray light-blue  f7 dim pointer noselect shadow-1 fw0' onClick={state}>{newOld}</div>
    )
}
export default NewOldButton;